<script>
import { routeStartsWith, routeIsProfessional } from '@/helpers/routes'

export default {
  name: 'QuickMenuMobilePatient',
  computed: {
    routeIsPatienteSettingsProfile () {
      return routeStartsWith(this.$route, 'settings.profile.me')
    },
    routeIsPatienteAgendaSearch () {
      return routeStartsWith(this.$route, 'patient.agendas.search')
    },
    routeIsPatienteAgendaSchedulings () {
      return routeStartsWith(this.$route, 'patient.agendas.schedulings')
    },
    routeIsProfessional () {
      return routeIsProfessional(this.$route)
    }
  }
}
</script>

<template lang="pug">
  .quick-menu-mobile.row.hidden-sm.hidden-md.hidden-lg(:class='{paciente: !routeIsProfessional}')
    ul
      li.col-xs-3(:class='{active: routeIsPatienteSettingsProfile}')
        router-link(:to="{name: 'settings.profile.me'}")
          span 

      li.col-xs-3(:class='{active: routeIsPatienteAgendaSearch}')
        router-link(:to="{name: 'patient.agendas.search'}")
          span 

      li.col-xs-3(:class='{active: routeIsPatienteAgendaSchedulings}')
        router-link(:to="{name: 'patient.agendas.schedulings'}")
          span 

      //-li.col-xs-3
        router-link(:to="{name: ''}")
          | 
          span.notification
</template>



// WEBPACK FOOTER //
// src/layout/quickMenuMobilePatient.vue